var // Re-recreate the enum from html5-qrcode to avoid importing the entire module
// We keep it in sync by running a test with Jest
SupportedCodeFormats;
(function(SupportedCodeFormats) {
    SupportedCodeFormats[SupportedCodeFormats["QR_CODE"] = 0] = "QR_CODE";
    SupportedCodeFormats[SupportedCodeFormats["AZTEC"] = 1] = "AZTEC";
    SupportedCodeFormats[SupportedCodeFormats["CODABAR"] = 2] = "CODABAR";
    SupportedCodeFormats[SupportedCodeFormats["CODE_39"] = 3] = "CODE_39";
    SupportedCodeFormats[SupportedCodeFormats["CODE_93"] = 4] = "CODE_93";
    SupportedCodeFormats[SupportedCodeFormats["CODE_128"] = 5] = "CODE_128";
    SupportedCodeFormats[SupportedCodeFormats["DATA_MATRIX"] = 6] = "DATA_MATRIX";
    SupportedCodeFormats[SupportedCodeFormats["MAXICODE"] = 7] = "MAXICODE";
    SupportedCodeFormats[SupportedCodeFormats["ITF"] = 8] = "ITF";
    SupportedCodeFormats[SupportedCodeFormats["EAN_13"] = 9] = "EAN_13";
    SupportedCodeFormats[SupportedCodeFormats["EAN_8"] = 10] = "EAN_8";
    SupportedCodeFormats[SupportedCodeFormats["PDF_417"] = 11] = "PDF_417";
    SupportedCodeFormats[SupportedCodeFormats["RSS_14"] = 12] = "RSS_14";
    SupportedCodeFormats[SupportedCodeFormats["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
    SupportedCodeFormats[SupportedCodeFormats["UPC_A"] = 14] = "UPC_A";
    SupportedCodeFormats[SupportedCodeFormats["UPC_E"] = 15] = "UPC_E";
    SupportedCodeFormats[SupportedCodeFormats["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
})(SupportedCodeFormats || (SupportedCodeFormats = {}));

export { SupportedCodeFormats };
//# sourceMappingURL=types.js.map
